var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"gen-header"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"childs"},[_c('div',{staticClass:"page-title"},[_vm._v("Media")])])])],1)],1),_c('news-page'),_c('call-us')],1)}
var staticRenderFns = []

export { render, staticRenderFns }